(function () {
  if (window.MExpandableTextLoaded) return;
  window.MExpandableTextLoaded = true;

  function expand(panel) {
    panel.style.maxHeight = panel.scrollHeight + 'px';
    panel.addEventListener('transitionend', function te(ev) {
      if (ev.propertyName === 'max-height') {
        panel.style.maxHeight = 'none';
        panel.removeEventListener('transitionend', te);
      }
    });
  }

  function collapse(panel) {
    panel.style.maxHeight = panel.scrollHeight + 'px';
    // Force reflow so the transition runs from the fixed height back to 0.
    panel.offsetHeight;
    panel.style.maxHeight = '0px';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-expandable-toggle]');
    if (!btn) return;

    var root = btn.closest('[data-expandable-root]');
    if (!root) return;

    var panel = root.querySelector('[data-expandable-panel]');
    var isExpanded = root.classList.toggle('is-expanded');
    btn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');

    if (!panel) return;
    if (isExpanded) {
      expand(panel);
    } else {
      collapse(panel);
    }
  });

  window.addEventListener('resize', function () {
    document
      .querySelectorAll('[data-expandable-root].is-expanded [data-expandable-panel]')
      .forEach(function (panel) {
        if (panel.style.maxHeight && panel.style.maxHeight !== 'none') {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
  });
})();
